// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Content-Card-Dashboard {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  justify-content: center;
  margin: 5px;
  width: 95%;
}

.box-Card {
  margin: 10px;
}

.box-update {
  display: flex;
  justify-content: center;
}

.box-dashboard {
  width: 600px;
  margin: 10px;
}

.label {
  margin-bottom: 5px;
}

.dashboard-card {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.dahsboard-searchbar {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}

@media only screen and (min-width: 800px) and (max-width: 900px) {
  .box-dashboard {
    width: 380px;
  }
}

@media only screen and (min-width: 700px) and (max-width: 800px) {
  .Content-Card-Dashboard {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }

  .box-Card {
    margin-top: 2%;
    margin: 10px;
    margin-left: 10px;
  }

  .box-dashboard {
    width: 300px;
    margin: 10px;
  }
}

@media only screen and (min-width: 600px) and (max-width: 700px) {
  .box-dashboard {
    width: 400px;
  }

  .Content-Card-Dashboard {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
}

@media only screen and (max-width: 600px) {
  .box-dashboard {
    width: 450px;
  }

  .Content-Card-Dashboard {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  .box-update {
    display: flex;
    flex-wrap: wrap;
    margin: 10px
  }

  .dahsboard-searchbar {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
}

@media only screen and (max-width: 470px) {
  .box-dashboard {
    width: 390px;
  }

  .dahsboard-searchbar {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
}

@media only screen and (max-width: 400px) {
  .box-dashboard {
    width: 350px;
  }

  .Content-Card-Dashboard {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }

  .box-Card {
    width: 330px;
  }

  .Content-Card-Dashboard {
    width: 80%;
  }

  .dahsboard-searchbar {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/style/dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,uBAAuB;EACvB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;IACb,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,eAAe;IACf;EACF;;EAEA;IACE,aAAa;IACb,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,qCAAqC;EACvC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,qCAAqC;EACvC;AACF","sourcesContent":[".Content-Card-Dashboard {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  justify-content: center;\n  margin: 5px;\n  width: 95%;\n}\n\n.box-Card {\n  margin: 10px;\n}\n\n.box-update {\n  display: flex;\n  justify-content: center;\n}\n\n.box-dashboard {\n  width: 600px;\n  margin: 10px;\n}\n\n.label {\n  margin-bottom: 5px;\n}\n\n.dashboard-card {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.dahsboard-searchbar {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n}\n\n@media only screen and (min-width: 800px) and (max-width: 900px) {\n  .box-dashboard {\n    width: 380px;\n  }\n}\n\n@media only screen and (min-width: 700px) and (max-width: 800px) {\n  .Content-Card-Dashboard {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n  }\n\n  .box-Card {\n    margin-top: 2%;\n    margin: 10px;\n    margin-left: 10px;\n  }\n\n  .box-dashboard {\n    width: 300px;\n    margin: 10px;\n  }\n}\n\n@media only screen and (min-width: 600px) and (max-width: 700px) {\n  .box-dashboard {\n    width: 400px;\n  }\n\n  .Content-Card-Dashboard {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .box-dashboard {\n    width: 450px;\n  }\n\n  .Content-Card-Dashboard {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .box-update {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 10px\n  }\n\n  .dahsboard-searchbar {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media only screen and (max-width: 470px) {\n  .box-dashboard {\n    width: 390px;\n  }\n\n  .dahsboard-searchbar {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media only screen and (max-width: 400px) {\n  .box-dashboard {\n    width: 350px;\n  }\n\n  .Content-Card-Dashboard {\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  .box-Card {\n    width: 330px;\n  }\n\n  .Content-Card-Dashboard {\n    width: 80%;\n  }\n\n  .dahsboard-searchbar {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
